module.exports = __webpack_public_path__ + "static/war-46a6edcbf5e8a579bb5c2b1815626539.png";